import { AnnouncementDto } from '@careapp-group/ng-sdk';
import { ModelEventDto } from '@careapp-group/ng-sdk';
import * as actions from '../actions/index';
import { RECENTLY_VIEWED } from '../actions/index';
import { ORGANISATION_CONTEXT_SWITCH } from '../actions/meta.actions';
import { DataListState, INITIAL_DATA_LIST_STATE } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';

export interface AnnouncementHistory {
  entities: { [id: string]: ModelEventDto[] };
  error: string;
  ids: string[];
  loading: boolean;
}

export interface AnnouncementsState extends DataListState<AnnouncementDto> {
  history: AnnouncementHistory;
  totalCount: number;
}

export class AnnouncementReducer extends ReducerStateFactory<AnnouncementDto> {
  initialState: AnnouncementsState = {
    ...INITIAL_DATA_LIST_STATE,
    history: {
      entities: {},
      error: '',
      ids: [],
      loading: false,
    },
    totalCount: 0,
  };

  public reducer(
    stateData: AnnouncementsState = this.initialState,
    action: actions.CAAction | any,
  ): AnnouncementsState {
    switch (action.type) {
      case ORGANISATION_CONTEXT_SWITCH:
        return { ...stateData, entities: {}, ids: [], selectedId: null };
      case actions.Announcements.REQUEST_TOTAL_COUNT:
        return { ...stateData, totalCount: null };
      case actions.Announcements.RESPONSE_SUCCESS_TOTAL_COUNT:
        return { ...stateData, totalCount: action.payload };
      case actions.Announcements.REQUEST_ALL:
        return { ...stateData, entities: {}, ids: [], loadingAll: true };
      // Update with a temporary flag to stop this announcement from logging a view multiple times in a session.
      case actions.Announcements.RESPONSE_SUCCESS_LOG_VIEW: {
        const newEntity = { ...stateData.entities[action.announcementId] };
        newEntity[RECENTLY_VIEWED] = true;
        const newEntities = { ...stateData.entities, [action.announcementId]: newEntity };
        return { ...stateData, entities: newEntities };
      }
      case actions.Announcements.RequestHistory.type: {
        return {
          ...stateData,
          history: { ...stateData.history, loading: true },
        };
      }
      case actions.Announcements.ResponseFailHistory.type: {
        return {
          ...stateData,
          history: { ...stateData.history, loading: false, error: action.error },
        };
      }
      case actions.Announcements.ResponseSuccessHistory.type: {
        const history: ModelEventDto[] = action.history;
        const newHistoryEntities = {
          ...stateData.history.entities,
          [action.announcementId]: history,
        };
        const newHistoryIds = [...new Set([...stateData.history.ids, action.announcementId])];
        return {
          ...stateData,
          history: {
            ...stateData.history,
            ids: newHistoryIds,
            entities: newHistoryEntities,
            loading: false,
          },
        };
      }
      default:
        return {
          ...super.reducer(stateData, action),
          totalCount: stateData.totalCount,
          history: stateData.history,
        };
    }
  }
}

export const state = new AnnouncementReducer(actions.Announcements);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
